export default __webpack_public_path__ + "static/media/repo-creation-ss.a8be686d.jpg";